import { HeaderSEOBlockContainer } from '@/microfrontends/listing/shared/containers/HeaderSEOBlockContainer';
import { QuickLinksContainer } from '@/microfrontends/listing/shared/containers/QuickLinksContainer';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';
import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';

import { ListingViewModeSwitcherContainer } from '../ListingViewModeSwitcherContainer';

import { SEOBlockLayout } from './components/SEOBlockLayout';

export const SEOBlock = memoWithDisplayName(() => {
  const isNarrow = useListingLayoutIsNarrowSelector();

  return (
    <SEOBlockLayout
      header={<HeaderSEOBlockContainer />}
      isNarrow={isNarrow}
      quickLinks={<QuickLinksContainer />}
      viewModeSwitcher={<ListingViewModeSwitcherContainer />}
    />
  );
}, 'SEOBlock');
